// extracted by mini-css-extract-plugin
export var focusVisible = "Gl1OI0ARZu5Tqxb1dppB";
export var icon = "mghbzs3in1X8X2hUpWgT";
export var isCheapest = "G8IlHPNVv6a1dRtvWhvL";
export var placeholder = "rL4BsaA8vqJBTvyGk3S0";
export var priceTag = "ye5NEQZth5SH0PLeIgjH";
export var priceWrapper = "F5ADlE2y044PwKVnfOMW";
export var shimmer = "_AOUUXjD8xWmTJaRl99b";
export var skeleton = "E38zFEEfx1NvegzIvILo";